export const escalationStatusENUM = {
  CREATED: 'CREATED',
  IN_PROGRESS: 'IN_PROGRESS',
  RESOLVED: 'RESOLVED',
  REJECTED: 'REJECTED'
};

export const actionCtaENUM = {
  ESCALATE: 'ESCALATE',
  RE_ESCALATE: 'RE_ESCALATE',
  RESOLVE: 'RESOLVE'
};

export const escalationCategoryENUM = {
  VAS: 'VAS',
  QC: 'QC',
  QC_VAS: 'QC_VAS'
};

export const escalationCategoryMapper = {
  VAS: 'VAS',
  QC: 'QC',
  QC_VAS: 'QC VAS'
};

export const statusChipMapper = {
  ['In-Progress']: {
    label: 'In Progress',
    color: 'pending'
  },
  ['RESOLVED']: {
    label: 'Resolved',
    color: 'success'
  }
};

export const categoryOptions = [
  {
    label: 'All',
    value: ''
  },
  {
    label: 'QC',
    value: escalationCategoryENUM.QC
  },
  {
    label: 'VAS',
    value: escalationCategoryENUM.VAS
  },
  {
    label: 'QC VAS',
    value: escalationCategoryENUM.QC_VAS
  }
];

export const statusOptions = [
  {
    label: 'All',
    value: ''
  },
  {
    label: 'CREATED',
    value: escalationStatusENUM.CREATED
  },
  {
    label: 'IN-PROGRESS',
    value: escalationStatusENUM.IN_PROGRESS
  },
  {
    label: 'RESOLVED',
    value: escalationStatusENUM.RESOLVED
  }
];
